import * as React from 'react';
interface IIconC {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const IconC: React.FC<IIconC> = (props) => {
    const { color } = props;
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <path
                    d="M7 0a7.002 7.002 0 016.93 6H16l-3 4-3-4h2.84A5.925 5.925 0 001.076 7a5.923 5.923 0 005.685 5.918l.238.005V14A7 7 0 017 0z"
                    id="IconC_a"
                />
            </defs>
            <use fill={color} xlinkHref="#IconC_a" transform="translate(0 1)" fillRule="evenodd" />
        </svg>
    );
};

export default IconC;
